module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei2.svg";